import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { Loader } from 'semantic-ui-react';

import { useAppStateFeedSelector } from '../feedSlice';
import { loadNewsPosts } from '../feedActionCreators';
import { FeedCard } from './FeedCard';
import { SliderArrow } from '../../../components/sliderArrow/SliderArrow';
import useWindowDimensions from '../../../store/utilities/useWindowDimensions';
import { useAuthSelector } from '../../auth/authSlice';

import styles from './NewsFeedPreview.module.scss';

export const NewsFeedPreview: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { width } = useWindowDimensions();
    const { isAuthenticated } = useAuthSelector((state) => state);
    const { newsPosts, newsLoading } = useAppStateFeedSelector((state) => state);

    useEffect(() => {
        // Load 9 news posts on mount
        dispatch(loadNewsPosts(1, 9));
    }, [dispatch]);

    const getSlidesToShow = () => {
        if (width) {
            if (width < 750) {
                return 1;
            } else if (width < 1400) {
                return 2;
            } else if (isAuthenticated) {
                return 2;
            } else {
                return 3;
            }
        }
        return 1;
    };

    const sliderSettings = {
        dots: false,
        infinite: false, // Don't loop with only 3 items
        speed: 500,
        slidesToShow: getSlidesToShow(),
        slidesToScroll: 1,
        prevArrow: <SliderArrow arrowDirection="left" />,
        nextArrow: <SliderArrow arrowDirection="right" />,
    };

    return (
        <div
            className={
                isAuthenticated
                    ? styles.newsPreviewDashboardContainer
                    : styles.newsPreviewContainer
            }
        >
            <div className={styles.header}>
                <h2>{t('Home.LatestNews')}</h2>
            </div>

            {newsLoading ? (
                <div className={styles.loaderContainer}>
                    <Loader active inline="centered">
                        Loading news...
                    </Loader>
                </div>
            ) : !newsPosts || newsPosts.length === 0 ? (
                <div className={styles.emptyState}>
                    <p>No news available</p>
                </div>
            ) : (
                <>
                    <div className={styles.sliderContainer}>
                        <Slider {...sliderSettings}>
                            {newsPosts.map((post) => (
                                <div key={post.id} className={styles.slideWrapper}>
                                    <FeedCard post={post} />
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div className={styles.viewAllLink}>
                        <Link to="/news">View All News</Link>
                    </div>
                </>
            )}
        </div>
    );
};
